'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AiIndividual1 = function (_React$Component) {
    _inherits(AiIndividual1, _React$Component);

    function AiIndividual1() {
        _classCallCheck(this, AiIndividual1);

        return _possibleConstructorReturn(this, (AiIndividual1.__proto__ || Object.getPrototypeOf(AiIndividual1)).apply(this, arguments));
    }

    _createClass(AiIndividual1, [{
        key: 'svgPath',
        value: function svgPath(strokeColor, strokeWidth) {
            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement(
                    'g',
                    null,
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M46.666,42.601c0,1.668-0.507,2.983-1.522,3.949c-1.011,0.967-2.36,1.45-4.04,1.45H22.896c-1.68,0-3.029-0.483-4.041-1.449 c-1.015-0.966-1.522-2.282-1.522-3.949c0-0.735,0.024-1.452,0.073-2.154s0.146-1.458,0.292-2.272 c0.146-0.811,0.331-1.565,0.553-2.26c0.222-0.693,0.52-1.37,0.896-2.029c0.374-0.659,0.805-1.221,1.291-1.689 c0.486-0.465,1.079-0.835,1.78-1.115c0.702-0.276,1.477-0.416,2.324-0.416c0.125,0,0.416,0.152,0.875,0.45 c0.456,0.298,0.975,0.632,1.549,1c0.577,0.368,1.328,0.702,2.251,1c0.924,0.298,1.85,0.447,2.78,0.447 c0.933,0,1.859-0.149,2.783-0.447s1.674-0.632,2.248-1c0.577-0.368,1.094-0.702,1.552-1c0.459-0.298,0.75-0.45,0.875-0.45 c0.848,0,1.622,0.14,2.324,0.416c0.702,0.28,1.294,0.65,1.78,1.115c0.486,0.468,0.917,1.03,1.291,1.689 c0.377,0.659,0.674,1.337,0.896,2.029c0.222,0.696,0.407,1.449,0.553,2.26c0.146,0.814,0.243,1.571,0.292,2.272 C46.642,41.149,46.666,41.866,46.666,42.601z M37.655,18.342C39.217,19.907,40,21.79,40,23.999s-0.784,4.092-2.345,5.657 c-1.562,1.562-3.448,2.342-5.657,2.342c-2.206,0-4.092-0.781-5.654-2.342c-1.565-1.565-2.345-3.448-2.345-5.657 s0.781-4.092,2.345-5.657C27.906,16.781,29.793,16,31.998,16C34.207,16,36.094,16.781,37.655,18.342z' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var strokeColor = this.props.strokeColor || 'white';
            var strokeWidth = this.props.strokeWidth || 0;
            var viewBox = '0 0 64 64';
            var style = {
                fontSize: '200%',
                verticalAlign: '-23%'
            };

            if (this.props.noPad) {
                viewBox = '16 16 32 32';
                style = {};
            }

            var props = _underscore2.default.omit(this.props, 'noPad', 'strokeColor');

            if (this.props.strokeWidth > 0) {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-individual-1', viewBox: viewBox, style: style }, props),
                    this.svgPath(strokeColor, strokeWidth),
                    this.svgPath('white', 0)
                );
            } else {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-individual-1', viewBox: viewBox, style: style }, props),
                    this.svgPath('white', 0)
                );
            }
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return Object.assign({}, _reactIconBase2.default.propTypes, {
                strokeColor: _propTypes2.default.string,
                strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
                noPad: _propTypes2.default.bool
            });
        }
    }]);

    return AiIndividual1;
}(_react2.default.Component);

exports.default = AiIndividual1;